export default {
  ENVIROMENT_KEYS: () => ({
    //Azure clientID to be used for Azure B2C tenant Application.
    CLIENT_ID: '19bdee4a-2166-40a9-bfa9-f9aaf19f2950',

    //Azure redirection URL to be used for Azure B2C tenant Application.
    DISCOVERY_URL:
      'https://schneidercarrier.b2clogin.com/schneidercarrier.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signup_signin',

    REDIRECT_URI: 'https://www.jwt.ms',

    //Token to be used for consuming Firebase notification features.
    FIREBASE_TOKEN: '',

    //App release name for release stage
    RELEASE: 'production',

    //Key to be used to consume Azure map features.
    AZURE_MAP_CLIENT_ID: '2dbbcf05-3325-4a60-b6cf-7d594264ec8e',

    //Host url to be used to trigger carrier Api services.
    API_HOST: 'api.schneider.com/external/005/carrier',

    //Subscription key to be used to athorize the API endpoints.
    SUBSCRIPTION_KEY: '6569aea3d9e943e0b610c320ca62a92a',

    //Host url to be used to trigger notification service
    NOTIFICATION_API_HOST:
      'api.schneider.com/external/005/api/notification',

    //Subscription key for notification service
    NOTIFICATION_SUBSCRIPTION_KEY: '6569aea3d9e943e0b610c320ca62a92a',

    //Azure scope url to be used as part of Azure authentication.
    AZURE_API_HOST: 'https://schneidercarrier.onmicrosoft.com',

    //Azure redirect url to be navigated upon authentication.
    AZURE_REDIRECT_URL:
    'https://freightpower.schneider.com/carrier/login',

    //Azure redirect url to be navigated upon authentication.
    AZURE_REDIRECT_URL_LOGOUT:
    'https://freightpower.schneider.com/carrier/logout',

    //Azure redirect url to be navigated upon authentication.
    AZURE_RESET_URL:
      'https://schneidercarrier.b2clogin.com/schneidercarrier.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_PasswordReset',

    // GPS env custom filter
    GEO_PRE_ARRIVAL_RADIUS: 3300, // Approximately 2 miles
    
    // Firebase Remote Config
    minimumFetchIntervalInSec: 60, //minimum Fetch Interval In 60 Sec

    //Google Maps API key
    GOOGLE_MAPS_API_KEY: 'AIzaSyDUH19bs4-bS-GUP0pDve7PD42jpRxf4GQ',

    // Host url to be used to trigger Azure Api services.
    AZURE_PREFERENCE_API_HOST:
      'api.schneider.com/external/005/preference-service',

    //Subscription key to be used to athorize the Azure endpoints.
    AZURE_PREFRENCES_SUBSCRIPTION_KEY: 'cdd0a3f5c6b44d0597be1f17d27a0b53',

    // PCmiler API Key
    PCMILER_API_KEY: '299354C7A83A67439273691EA750BB7F',

    // // Analytics Conffig for Prod-alpha
    // FIRBASE_ANALYTICS_CONFIG: {
    //   apiKey: 'AIzaSyDO5x-GPZ8XvQEJfRgVYj-vBUKv0MdxUXA',
    //   authDomain: 'freightpower-for-carriers-prod.firebaseapp.com',
    //   databaseURL: 'https://freightpower-for-carriers-prod.firebaseio.com',
    //   projectId: 'freightpower-for-carriers-prod',
    //   storageBucket: 'freightpower-for-carriers-prod.appspot.com',
    //   messagingSenderId: '520096226869',
    //   appId: '1:520096226869:web:7e81260c91b1d776f69b7c',
    //   measurementId: 'G-WX3EB11532',
    // },

    // Analytics Conffig for Prod-Release
    FIRBASE_ANALYTICS_CONFIG: {
      apiKey: 'AIzaSyB0nrtmn0h2cp3xaApHBhVL88O0LFzsePU',
      authDomain: 'freightpower-for-carrier.firebaseapp.com',
      databaseURL: 'https://freightpower-for-carrier.firebaseio.com',
      projectId: 'freightpower-for-carrier',
      storageBucket: 'freightpower-for-carrier.appspot.com',
      messagingSenderId: '291826048107',
      appId: '1:291826048107:web:2fab516b61e6a6dfb4252e',
      measurementId: 'G-89VVQ0L7KK',
    },
    ADJUST_CONFIG: {
      appToken: 'd5wqixwkfqww',
      linkToken: '1q79kozp',
      environment: 'production',
      logLevel: 'verbose',
    },
  }),
};
